<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>

    import {mapState, mapGetters} from 'vuex'

    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                state: true,
                isLogIn: localStorage.getItem('isLogIn'),
                CurrentUser: '',
                dialog: false,
                drawer: null,
            }
        },
        computed: {
            ...mapState,
            ...mapGetters([
                'carShop',
            ]),
        },
        created(){
            this.getUserGeo()
        },
        methods: {
            getUserGeo(){
                this.$store.dispatch('auth/getUserGeo')
            },
        },
    }
</script>

<style>
    .button-menu{
        font-size: 3rem;
        cursor: pointer
    }
    @media screen and (max-width: 768px) {
        .hide{
            margin-top: 100px;
        }
    }
</style>
